import { ThemeProperties } from '../../core';

export interface TabNavigationTheme {
	triggerPadding: string; // tokens.spacing.x1
	triggerFont: string;
	triggerActiveFont: string;
	triggerPassiveColor: string; // tokens.color.content.muted
	triggerActiveColor: string; // tokens.color.content.default
	triggerActiveBackground: string; // tokens.color.content.interactive
	triggerHoverColor: string; // tokens.color.content.interactive
	sliderBackground: string; // tokens.color.border.default
}

export const theme = new ThemeProperties('tabNavigation');
